<template>
  <b-container fluid class="page-footer">
    <b-container class="footer-content">
      <b-row class="justify-content-md-center text-center">
        <b-col class="link-wording">
          <router-link to="/home">{{ $t('i18n.Website.Home') }}</router-link>
          <router-link to="/about">{{ $t('i18n.Website.About') }}</router-link>
          <router-link to="/blog">{{ $t('i18n.Website.Blog') }}</router-link>
          <router-link to="/faq">{{ $t('i18n.Website.FAQ') }}</router-link>
        </b-col>
        <b-col class="unlink-wording">
          <router-link to="/services">{{ $t('i18n.Website.Services') }}</router-link>
          <div v-for="item in $t('i18n.Website.ServicesList')" :key="item.id">
            <div class="small-link-wording">{{ item.name }}</div>
          </div>
        </b-col>
        <b-col class="unlink-wording">
          <router-link to="/contactus">{{ $t('i18n.Website.ContractUs') }}</router-link>
          <div v-for="item in $t('i18n.Website.ContactUSInfo')" :key="item.id">
            <b-row>
              <b-col cols="2">{{ item.key }}</b-col>
              <b-col cols="10">{{ item.value }}</b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="policy-bottom">
          <span>{{ $t('i18n.Website.copyRightWording') }}</span>
          <router-link to="/policy">{{ $t('i18n.Website.privacyPolicy') }}</router-link>
          <router-link to="/terms">{{ $t('i18n.Website.copyrightIPolicy') }}</router-link>
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
export default {
  name: 'PageFooter'
}
</script>

<style lang="scss">
.page-footer {
  background: #384558;
  padding-top: 40px;
  min-width: 100%;
  padding-bottom: 12px;
}

.footer-content {
  width: 100;
}

@media (min-width: 1000px) {
  .page-footer {
    min-width: 1000px;
  }

  .footer-content {
    width: 1000px;
  }
}

@media (max-width: 500px) {
  .page-footer {
    display: none
  }
}
.link-wording {
  a {
    display: flex;
    flex-direction: column;
    color: #ffffff !important;
    font-size: 14px;
    line-height: 36px;
    margin-bottom: 23px;
    cursor: pointer;
  }

  a:hover {
    color: #ffffff !important;
  }
}

.unlink-wording {
  a {
    display: flex;
    flex-direction: column;
    color: #ffffff !important;
    font-size: 14px;
    line-height: 36px;
    margin-bottom: 5px;
    cursor: pointer;
  }

  a:hover {
    color: #ffffff !important;
  }

  div {
    font-size: 12px;
    color: #ffffff;
    line-height: 36px;
    opacity: 0.8;
    white-space: nowrap;
  }
}

.col {
  text-align: left;
}

.policy-bottom {
  color: #ffffff;
  font-size: 12px;
  text-align: center;
  margin-top: 46px;

  span {
    margin-right: 15px;
  }

  a {
    margin-right: 15px;
    color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/Layout/components/page-footer.vue